export default __webpack_public_path__ + "static/media/her1.4776445a.svg";